import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (failureCount >= 2) return false;
        if (error instanceof Error && /401|403/.test(error.message)) return false;
        return true;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
